import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

import './Footer.css';

import logo from '../../../assets/images/logo_horizental.jpg'
import { useTranslation } from "react-i18next";
import Media from 'react-media';

const Footer = ({ lang, SetLang }) => {
    const [t, i18n] = useTranslation('traduction');

    useEffect(() => {
        i18n.changeLanguage(lang);
    }, [i18n, lang]);
    return (
        <>

            <footer class="site-footer style1">



                <div class="section-full p-t50 p-b20 bg-primary text-white overlay-primary-dark footer-info-bar">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-3 col-md-6 col-sm-6 m-b30">
                                <div class="icon-bx-wraper bx-style-1 p-a20 radius-sm br-col-w1">
                                    <div class="icon-content">
                                        <h5 class="dlab-tilte">
                                            <span class="icon-sm"><i class="ti-location-pin"></i></span>
                                            {t('Address')}
                                        </h5>
                                        <p class="op7">{t('Route de Tunis km24, Z.I. Ghraba 3043, Sfax - Tunisie')} </p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-6 col-sm-6 m-b30">
                                <div class="icon-bx-wraper bx-style-1 p-a20 radius-sm br-col-w1">
                                    <div class="icon-content">
                                        <h5 class="dlab-tilte">
                                            <span class="icon-sm"><i class="ti-email"></i></span>
                                            {t('E-mail')}
                                        </h5>
                                        <p class="m-b0 op7"> direction.generale@devpack.com.tn</p>
                                        <p class="op7"> contact@devpack.com.tn</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-6 col-sm-6 m-b30">
                                <div class="icon-bx-wraper bx-style-1 p-a20 radius-sm br-col-w1">
                                    <div class="icon-content">
                                        <h5 class="dlab-tilte">
                                            <span class="icon-sm"><i class="ti-mobile"></i></span>
                                            {t('Numéros de téléphone')}
                                        </h5>
                                        <p class="m-b0 op7">{t('Tél:')}  +216 71 136 670</p>
                                        <p class="op7">{t('Fax:')}  +216 74 842 314</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-6 col-sm-6 m-b30">
                                <div class="icon-bx-wraper bx-style-1 p-a20 radius-sm br-col-w1">
                                    <div class="icon-content">
                                        <h5 class="dlab-tilte">
                                            <span class="icon-sm"><i class="ti-alarm-clock"></i></span>
                                            {t('Heures de travail')}
                                        </h5>
                                        <p class="m-b0 op7">{t('Du Lundi Au Samedi - 08.00-18.00')} </p>
                                        <p class="op7">{t('Dimanche - Fermé')} </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="footer-top">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-4 col-sm-6">
                                <div class="widget widget_about">
                                    <h4 class="footer-title">{t('A Propos De Lentreprise')}</h4>
                                    <p>
                                        {t('DEVPACK est une entreprise industrielle offrant des emballages plastiques standards ou personnalisés basés sur le mousse de polystyrène XPS.')}
                                    </p>
                                    {/* <Link to={"/about-2"} class="readmore">Read More</Link>  */}
                                </div>
                            </div>
                            <div class="col-md-4 col-sm-6">
                                <div class="widget">
                                    <h4 class="footer-title">{t('Liens Utiles')}</h4>
                                    <ul className="list-arrow primary reverse rounded ">
                                        <li><Link to={"/"}>{t('Accueil')}</Link></li>
                                        <li><Link to={"/presentation"}>{t('Présentation')}</Link></li>
                                        <li><Link to={"/produits"}>{t('Nos Produits')}</Link></li>
                                        <li><Link to={"/reference"}>{t('Nos Références')} </Link></li>
                                        <li><Link to={"/contact"}>{t('Contactez-Nous')} </Link></li>

                                    </ul>

                                </div>
                            </div>

                            <div class="col-md-4 col-sm-12">
                                <div class="widget widget_subscribe">


                                    <div className="single-widget widget-contact">
                                        <h5 className="widget-title">{t('Rendez nous visite')}</h5>
                                        <div className="mapouter">
                                            <div className="gmap_canvas">
                                                <iframe width="380" height="220" id="gmap_canvas"
                                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3270.8216209415423!2d10.745449614444164!3d34.936010378088355!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1301dba3dd316e93%3A0xc0e15b1bc04ca40f!2sDEVPACK!5e0!3m2!1sfr!2stn!4v1624440652546!5m2!1sfr!2stn"
                                                    frameBorder="0" scrolling="no" marginHeight="0"
                                                    marginWidth="0"></iframe>

                                                <a href="https://torrent9-fr.com"></a></div>

                                        </div>
                                    </div>





                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="footer-bottom footer-line">
                    <div class="container">
                        <div class="footer-bottom-in ">
                            <Media query="(min-width: 591px)" render={() =>
                            (
                                <div class="footer-bottom-logo "><Link to={"/"}><img src={logo} alt="" /></Link></div>

                            )}
                            />
                            <div className="text-left py-1 ">

                                <h7> &copy; {new Date().getFullYear()} <>{t('Copyright :')} DEVPACK </> </h7>

                                <h6>{t('Designed by :')}
                                    <a href="https://www.linkedin.com/in/mahdi-hamdi-53b8151a5/" target="toggle" >Mahdi Hamdi</a>
                                    &amp;
                                    <a href="https://www.linkedin.com/in/ramez-ben-aribia/" target="toggle">
                                        Ramez Ben Aribia
                                    </a>
                                </h6>

                            </div>
                            <div className="row">
                                <Media query="(max-width: 591px)" render={() =>
                                (
                                    <div class="footer-bottom-logo "><Link to={"/"}><img src={logo} alt="" /></Link></div>

                                )} />
                                <div class="footer-bottom-social">
                                    <ul class="dlab-social-icon dez-border">
                                        <li><Link class="fa fa-facebook" to={"/#"}></Link></li>

                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </footer>

        </>
    );
}

export default Footer;








